import { render } from "./template_8.vue?vue&type=template&id=1d412b36&scoped=true"
import script from "./template_8.vue?vue&type=script&lang=js"
export * from "./template_8.vue?vue&type=script&lang=js"

import "./template_8.vue?vue&type=style&index=0&id=1d412b36&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d412b36"]])

export default __exports__